/**
 * It's a generated file, preferable to extend this in external file
 */
import {ServerTypeName} from 'common/enums';
import * as yup from 'common/yup';
import {passphrase} from 'common/yup/customs/passphrase';
import {AbstractServer} from 'types/transport/Abstract/AbstractServer';
import {serverTypeNameSchema} from 'types/transport/ServerTypeName';

export const SharepointNames = {
   clientId: 'clientId',
   clientSecret: 'clientSecret',
   tenantId: 'tenantId',
   address: 'address',
   siteName: 'siteName',
   drive: 'drive',
   typeName: 'typeName',
} as const;

export const SharepointServer = AbstractServer.shape({
   [SharepointNames.typeName]: serverTypeNameSchema.default(ServerTypeName.SHAREPOINT),
   [SharepointNames.clientId]: yup.idString().default(['']),
   [SharepointNames.tenantId]: yup.idString().default(['']),
   [SharepointNames.clientSecret]: passphrase(),
   [SharepointNames.address]: yup.string().default(['']),
   [SharepointNames.siteName]: yup.string().default(['']),
   [SharepointNames.drive]: yup.string().default(['']),
});
export type ISharepointServer = yup.InferType<typeof SharepointServer>;
